/**
 * Monatsnamen und Zeitraumtexte.
 *
 * Eigenes Modul, weil die Liste sonst zum dritten Mal irgendwo stünde —
 * Anschreiben, Preisfindungsmaske und Marktdaten brauchen sie alle.
 */

export const MONATSNAMEN = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
];

/** 1-basierter Monat. `monatJahr(12, 2026)` → „Dezember 2026". */
export function monatJahr(monat: number, jahr: number): string {
  const name = MONATSNAMEN[monat - 1];
  if (!name) throw new Error(`Ungültiger Monat: ${monat}`);
  return `${name} ${jahr}`;
}

/** Laufender Monat als „August 2026", gerechnet in UTC. */
export const laufenderMonat = (jetzt: number): string => {
  const d = new Date(jetzt);
  return monatJahr(d.getUTCMonth() + 1, d.getUTCFullYear());
};

/** Erster Tag des laufenden Monats als ISO-Zeitpunkt — Untergrenze für Filter. */
export const monatsanfang = (jetzt: number): string => {
  const d = new Date(jetzt);
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)).toISOString();
};

/**
 * Ab wann der Stand eines von Hand gepflegten Wertes angemerkt wird.
 *
 * Gilt fuer die Kontraktnotierungen, die bewusst KEINEN Monatsverfall haben:
 * Ein Dezemberkontrakt ist bis zu seiner Faelligkeit gueltig, nicht bis zum
 * Monatsende — eine Monatsgrenze wuerde am Ersten die halbe Terminkurve
 * ungueltig machen und jede Preisfindung blockieren. Statt zu blockieren
 * weist die Kachel auf ihr Alter hin.
 *
 * Liegt in `shared`, weil Kachel (Client) und Kontraktantwort (Worker)
 * dieselbe Schwelle nennen muessen.
 */
export const STAND_HINWEIS_TAGE = 14;
